import React from "react";
import { useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { CircularProgress, Container } from "@mui/material";
import "./main.css";
import { useTranslation } from "react-i18next";
import Dashboard from "../dashboard/Dashboard";
import AuthDialog from "../../components/common/AuthDialog";

function Main() {
  const { t } = useTranslation();
  const history = useNavigate();

  const loggedIn = useSelector((state) => state.user.loggedIn);
  const loggingIn = useSelector((state) => state.user.loading);
  const loading = useSelector((state) => state.myDesigns?.loading);
  const role = useSelector((state) => state.user.currentUser.account?.role);

  // const isBizDev = useSelector((state) =>
  //   state.user?.currentUser?.account?.rights.includes("bizDev")
  // );
  // const isSuperAdmin = useSelector(
  //   (state) => state.user?.currentUser?.account?.isSuperAdmin === 1
  // );

  // const isOnlyBizDev = () => {
  //   return isBizDev && !isSuperAdmin;
  // };

  React.useEffect(() => {
    let timerId;
    // if (role === "USER" || isOnlyBizDev()) {
    if (role === "USER") {
      timerId = setTimeout(() => {
        history("dashboard");
      }, 100);
    }
    return () => {
      clearTimeout(timerId);
    };
  }, [role, history]);

  if (!loggedIn) {
    return <AuthDialog />;
  } else {
    if (loggingIn || loading) {
      return (
        <Container>
          <div className="loading-container">
            <CircularProgress size={50} />
            <Typography>{t("loaders.fetching")}</Typography>
          </div>
        </Container>
      );
    } else if (role === "ADMIN") {
      return <Dashboard />;
    } else return null;
  }
}

export { Main };
